import { handleSaveEvent } from "../../../js/components/save-community";
import { handleOtherActions } from "../../../js/components/other-actions";
import { openCompareWidget } from "../../../js/components/compare-community";

// eslint-disable-next-line import/prefer-default-export
export const compareView = () => {
  let isSticky = false;
  const header = document.querySelector('.compare-view__body--thead');
  const body = document.querySelector('.compare-view__body');
  const save = document.querySelectorAll('[href="#save"]');
  const remove = document.querySelectorAll('[href="#remove"]');
  const clearAll = document.querySelectorAll('.clear-compare');
  const otherActions = document.querySelectorAll('.other');
  const addCommunity = document.querySelectorAll('[href="#add-community"]');

  if(body){
    const sticky = header.offsetTop - 100;

    function handleSticky() {
      if (window.scrollY > sticky) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    }

    window.onscroll = () => { handleSticky(); };

    body.onscroll = (e) => {
      const communityDetail = document.querySelectorAll('.compare-view__body--thead.sticky .community-detail');
      communityDetail.forEach((item) => {
        item.style.transform = 'translateX(-' + e.target.scrollLeft + 'px)';
      });
    }

    save.forEach((item) => {
      item.addEventListener('click', handleSaveEvent);
    });

    const removeCommunity = (id) => {
      document.querySelectorAll('[data-id="' + id + '"').forEach((item) => {
        item.remove();
      });

      let communityDetail = document.createElement('DIV');
      communityDetail.classList.add('community-detail', 'empty');

      let communityLink = document.createElement('A');
      communityLink.href = '#add-community';
      communityLink.innerHTML = '<svg class="add"><use xlink:href="#add"></use></svg>Add Community';
      communityLink.addEventListener('click', openCompareWidget);
      communityDetail.appendChild(communityLink);
      document.querySelector('.compare-view__body--thead').appendChild(communityDetail);

      const communityIndex = communitiesArray.communities.findIndex( obj => {
        return obj.Id === id;
      });

      communitiesArray.communities[communityIndex].IsCompare = false;
    }

    const handleRemove = (e) => {
      e.preventDefault();
      removeCommunity(e.currentTarget.getAttribute('data-id'));
    }

    remove.forEach((item) => {
      item.addEventListener('click', handleRemove);
    });

    const handleClearAll = () => {
      document.querySelectorAll('.community-detail[data-id]').forEach((item) => {
        removeCommunity(item.getAttribute('data-id'));
      });
    }

    clearAll.forEach(clear => clear.addEventListener('click', handleClearAll));

    addCommunity.forEach((item) => {
      item.addEventListener('click', openCompareWidget);
    });

    window.addEventListener('beforeprint', function () {
      const amount = header.querySelectorAll(".community-detail:not(.empty)");
      if (amount.length === 2) {
        header.classList.add('two-print-items');
      } else if (amount.length === 3) {
        header.classList.add('three-print-items');
      } else if (amount.length === 4) {
        header.classList.add('four-print-items');
      } else if (amount.length === 5) {
        header.classList.add('five-print-items');
      }
      document.body.classList.add('compare-print');
    });
    window.addEventListener('afterprint', function () {
      document.body.classList.remove('compare-print');
    });
  }
};



// WEBPACK FOOTER //
// ./src/templates/components/compare-view/compare-view.js